import { render, staticRenderFns } from "./fotor-mobile-outsite-app.vue?vue&type=template&id=5b249ab1"
import script from "./fotor-mobile-outsite-app.vue?vue&type=script&lang=js"
export * from "./fotor-mobile-outsite-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GoArtHeaderBar: require('/root/builds/ASbHBz4D/0/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/GoArtHeaderBar.vue').default,GoArtOpenInApp: require('/root/builds/ASbHBz4D/0/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/GoArtOpenInApp.vue').default,GoArtFullLoading: require('/root/builds/ASbHBz4D/0/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/loading/GoArtFullLoading.vue').default,GoArtDialogMsg: require('/root/builds/ASbHBz4D/0/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/GoArtDialogMsg.vue').default,GoArtToast: require('/root/builds/ASbHBz4D/0/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/GoArtToast.vue').default,GoArtConfirm: require('/root/builds/ASbHBz4D/0/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/GoArtConfirm.vue').default})
